// 首页智能推荐
var allowScrollHandler = true;
var click_num = 0;
function intelligent_recommend( clientId, email) {
    click_num+=1;
    var now = new Date(); // 获取当前日期和时间
  
       clientId ? clientId : '';
       email ?  email : '';
     var form = new FormData();
     form.append("cid", clientId);
     form.append("email", email);
     if(click_num>=2){
      product_ids=sessionStorage.getItem('recommend_products_ids');
      card_id=sessionStorage.getItem('recommend_card_id');
      form.append("all_product_id", product_ids);
      form.append("all_cards", card_id);
      form.append("page", click_num);
     }
     $.ajax({
       "url": "https://plugin.kriyya.com/api/klaiyi/recommend_products",
       "method": "POST",
       "timeout": 0,
       "headers": {
         "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
       },
       "processData": false,
       "mimeType": "multipart/form-data",
       "contentType": false,
       "data": form,
       success: function(res) {
        //  判断要不要滑动加载
        if(JSON.parse(res).code == 1){
          console.log('接口出现了几次',click_num);
          if(click_num>=2){
            sessionStorage.setItem('recommend_products',JSON.parse(res).data.content);
            $('.home_recommend .ProductListWrapper .ProductList').append(JSON.parse(res).data.content);
              video_list();  
              sessionStorage.setItem('recommend_products_ids',JSON.parse(res).data.all_product_id);
              sessionStorage.setItem('recommend_card_id',JSON.parse(res).data.all_cards);
           }else{
            $('.home_recommend .ProductListWrapper').html(JSON.parse(res).data.content);
              video_list();  
              sessionStorage.setItem('recommend_products_ids',JSON.parse(res).data.all_product_id);
              sessionStorage.setItem('recommend_card_id',JSON.parse(res).data.all_cards);
           }
           // 绑定滚动事件处理函数
           if(click_num<=7){
             console.log('加载次数aaaa',click_num);
            $(window).scroll(scrollEventHandler);
           }else{
            return false
           }
        }else{
          allowScrollHandler = false;
        }
          if(jQuery(window).width()<=768){
            $('.home_recommend .ProductListWrapper .ProductItem').each(function(){
              $(this).find('.tag_all_mark .tag_mark:gt(0)').hide();
            })
           }
          $('.home_recommend .ProductListWrapper .ProductItem .addCart_icon').each(function(){
            $(this).off("click").on("click",function(){
              let $this = $(this);
              if ($this.hasClass("disabled")) return; // 已禁用，不执行
          
              $this.addClass("disabled"); // 禁用点击
              setTimeout(() => {
                  $this.removeClass("disabled"); // 2秒后恢复
              }, 5000);
              if ($('.quick_shop_main').is(':visible')) {
                console.log('quick_shop_main 是显示的');
                $this.addClass("disabled"); // 禁用点击
              } else {
                  console.log('quick_shop_main 是隐藏的（display: none 或 visibility: hidden）',$('.quick_shop_main').css('display'));
                  quick_icon_click(jQuery(this),jQuery(this).parent().siblings().find('a').attr('href'));
        
              }
              
            })
          })
             $('img.pic_site').each(function () {
               $(this).attr('src', $(this).attr('data-src'));
             })
             var clickTimer = null;
             $('#shopify-section-template--15781914968198__36c2ef42-7a11-4457-89ad-da5261c73839 .SectionFooter a').on('click', function (event) {
                    event.preventDefault();
                     // 直接将页面滚动到顶部
                   $('html, body').scrollTop(0);
             })
       },
       error:function(req){
         console.log('错误返回值',req);
       }
     });
}

// 让函数变成全局可访问的
window.intelligent_recommend = intelligent_recommend;
// 遍历视频并且点击
function video_list(){
    $('.home_recommend .ProductListWrapper .ProductItem_video_img').each(function(){
      $(this).off("click").on("click",function(){
        console.log('点击视频，出现视频弹窗');
        sessionStorage.setItem('popupVisible', 'true'); // 设置状态
        // 关于产品信息的内容
        const product_mes=JSON.parse($(this).attr('data-json'));
        $('.video_product_cen a').attr('href','https://www.klaiyihair.com/products/' + product_mes.handle);
        $('.video_product_cen .video_product_left img').attr('src',product_mes.featured_image);
        $('.video_poupop .video_product_cen').attr('product-id',product_mes.product_id);
        $('.video_poupop .video_poupop_cen .video_product_title').text(product_mes.title);
        $('.video_poupop .video_poupop_cen .video_product_now_price').text('$'+ ((product_mes.price)/100).toFixed(2));
        $('.video_poupop .video_poupop_cen .video_product_old_price').text('$'+ ((product_mes.compare_at_price)/100).toFixed(2));
        if(jQuery(window).width()>768){
          $('.video_poupop .video_poupop_cen video').attr('controls', '');
        }
        $('.video_poupop .video_poupop_cen video').attr('data-video-src',$(this).attr('data-video-src'));
        $('.video_poupop .video_poupop_cen video').attr('poster',$(this).find('picture').find('.cover_pic').attr('src'));
        $('.video_poupop .video_poupop_cen source').attr('src',$(this).attr('data-video-src'));
            $('.video_product_cen a').on('click', function (event) {
              localStorage.setItem('video_scrol_top', newscrollTop);
              sessionStorage.removeItem('popupVisible'); // 清除状态
              var video = $('.video_poupop_cen_con video')[0]; // 获取video DOM对象
              const $video = $('.video_poupop_cen_con video');
              $video.prop('muted', true); // 关闭时静音
              $('.video_poupop .muteButton .iconfont').addClass('.icon-Volume-Up').removeClass('icon-Volume');
              $('.video_poupop .muteButton').show();
              $('.video_poupop .playBtn').attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552');
              video.pause(); //暂停控制
              setTimeout(function(){  
                $('.video_poupop .window-cover').css('display','none');
                $('.video_poupop .video_poupop_cen').css('display','none');
              },2000)
            })
        const $loading = $('#video_loading');
        $loading.show(); // 显示加载标记
        const $video = $('.video_poupop .video_poupop_cen video');
        const video = $('.video_poupop .video_poupop_cen video')[0];
        $video[0].currentTime = 0;                
        $('.video_poupop .video_poupop_cen_con .progressBar').css('width',0);
        $video.prop('muted', true); // 确保视频静音
        $video[0].load(); // 触发视频加载
          $video[0].addEventListener('loadeddata', function() {
              $loading.hide(); // 隐藏加载标记
              $video[0].play();
              $('.video_poupop .playBtn').attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame-1.png?v=1715329552');
               // 进度条
            var progressBar = $('.video_poupop .video_poupop_cen_con .progressBar');
            var handleProgress = function(){
              var percentage = (100 / video.duration) * video.currentTime;
              if((video.duration-video.currentTime)/60>1){
                var min_num=Math.floor((video.duration-video.currentTime)/60);
                if(min_num<10){
                  $('.end_min').text('0'+ min_num);
                }else{
                  $('.end_min').text(min_num);
                }
                if(Math.floor(video.duration-min_num*60-video.currentTime)<10){
                    $('.end_second').text('0'+ Math.floor(video.duration-min_num*60-video.currentTime)); 
                }else{
                    $('.end_second').text(Math.floor(video.duration-min_num*60-video.currentTime));
                }
              }else{
                 $('.end_min').text('00');
                if(Math.floor(video.duration-video.currentTime)<10){
                    $('.end_second').text('0'+ Math.floor(video.duration-video.currentTime)); 
                }else{
                    $('.end_second').text(Math.floor(video.duration-video.currentTime));
                }
                 
              }
              progressBar.css('width', percentage + '%');
            };
            $video[0].addEventListener('timeupdate', handleProgress, false);
          });
        
        $('.video_poupop .video_product .video_title_cen').text($(this).attr('data-video_name'));
  
        // 文案是否折叠
        const $text = $('.video_title_cen');
        const $button = $('.video_toggle_button'); 
        // 检查文本是否超出 2 行
        if ($text[0].scrollHeight > $text.outerHeight()) {
            $button.show(); // 显示展开按钮
        }
        // 点击按钮展开/折叠
        $button.on('click', function() {
            $('.video_title').toggleClass('expand');
            $(this).text($('.video_title').hasClass('expand') ? '╱╲' : '╲╱');
        });
         var newscrollTop = $(window).scrollTop();
         if(jQuery(window).width()>769){
          $('body').attr('data-overflow-top',newscrollTop);
          $('body').css({
            'overflow': 'hidden',
            'position': 'fixed',
            'top': '-' + newscrollTop + 'px',
            'left': '0',
            'right': '0',
            'bottom': '0'
          });
         }
  
        $('.video_poupop .window-cover').css('display','block');
        $('.video_poupop .video_poupop_cen').css('display','block');
      })
    })
}